<template>
  <div id="union-view">
    <union-module v-if="unionId>0&&isConfirm"
                  :unionId="unionId"
                  :classIds="classIds"
                  :classId="classId"
                  :adminUserId="adminUserId"
                  :expireTime="expireTime"
                  :mainClassId="mainClassId"
                  @confirm-order="confirm"
                  @page-invalid="jump"
                  @track-events="track">
    </union-module>
  </div>
</template>
<script>
import Vue from 'vue'
import $ from 'jquery'
import utils from '@/utils/utils'
import Confirm from '@/components/Confirm/index'
import { UnionModule } from 'lingdongliang-module'
Vue.use(Confirm)
Vue.use(UnionModule)

export default {
  data () {
    return {
      unionId: 0,
      classIds: [],
      classId: 0,
      adminUserId: 0,
      expireTime: 0,
      mainClassId: 0,
      isConfirm: true,
      priceInfo: {}
    }
  },
  components: {
    UnionModule
  },
  methods: {
    confirm (obj) {
      this.isConfirm = false
      this.priceInfo = obj.priceInfo
      this.$confirmOrder(obj.priceInfo, obj.class_list, 'union-view', '', this.unionId, obj.materials_info, obj.invited_id)
    },
    jump () {
      this.$router.push({ path: '/' })
      $('body').removeAttr('class')
    },
    track ({ node, props }) {
      this.zhuGeEventTrack(node, props)
    }
  },
  mounted () {
    this.unionId = Number(this.$route.params.unionId)
    if (this.$route.query.u) {
      this.adminUserId = Number(this.$route.query.u)
    }
    if (this.$route.query.c) {
      this.classIds = this.$route.query.c.split(',')
    }
    if (this.$route.params.classId) {
      this.mainClassId = Number(this.$route.params.classId)
      this.classId = Number(this.$route.params.classId)
      this.classIds = [this.classId]
    }
    if (this.$route.query.e) {
      this.expireTime = utils.hex2int(this.$route.query.e)
    }
    // this.unionId = Number(this.$route.params.unionId)
  }
}
</script>
<style lang="scss">
  #union-view{
    padding-top: 0;
    position: relative;
    min-height: 100vh;
    box-sizing: border-box;
  }
</style>
